export enum Application {
  APP1 = 'App1',
  APP2 = 'App2',
  CLM = 'CLM',
  COLLECTIONS = 'Collections',
  DASHBOARD = 'Dashboard',
  DD = 'Destiny Discover',
  DESTINY = 'Library Manager',
  DESTINY_AI = 'Destiny AI',
  DESTINY_EXPRESS = 'Destiny Express',
  DESTINY_UI = 'Destiny UI',
  DISCOVER_MANAGER = 'Discover Admin',
  FM = 'Fundraising Manager',
  FOLLETT_COMMUNITY = 'Follett Community',
  JUNIPER_SIDECAR = 'Juniper Sidecar',
  MASTERLIBRARY_DRAWINGS = 'Drawings',
  MASTERLIBRARY_HELPDESK = 'Help Desk',
  MASTERLIBRARY_ITAM = 'IT Asset Manager',
  MASTERLIBRARY_SCHEDULES = 'Schedules',
  MASTERLIBRARY_WORKORDERS = 'Work Orders',
  PORTAL = 'Portal',
  PSARI = 'PSARI',
  READER = 'Reader',
  TITLEWAVE = 'Titlewave',
  UNIFIED_SETTINGS = 'UNS'
}
export enum AppGroup {
  DESTINY = 'DESTINY',
  FACILITIES = 'FACILITIES',
  SHOP = 'SHOP',
  SUPPORT = 'SUPPORT',
  TECHNOLOGY = 'TECHNOLOGY'

}

export class ClientInfo {
  public static ID: Application;
  public static PORTAL_ID: string;
  public static PARENT_ORIGIN: string = 'set portal origin';
}
